import { render } from "./TheFooter.vue?vue&type=template&id=c4de11ec"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=c4de11ec&lang=scss"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__